import React, { Component } from 'react';
import '../assets/css/style.css';
import '../assets/css/responsive.css';
import {Route, NavLink, BrowserRouter, Switch} from 'react-router-dom';
import {Grid} from 'semantic-ui-react';
import Home from './home/Home';

import Tours from './tours/Tours';
import TourBalkan from './tours/TourBalkan';
import TourNZ from './tours/TourNZ';
import TourHolyLand from './tours/TourHolyLand';
import TourIcelandSummer from './tours/TourIcelandSummer';
import TourIcelandWinter from './tours/TourIcelandWinter';
import TourCANY from './tours/TourCANY';
import TourAfrica from './tours/TourAfrica';
import TourBaltic from './tours/TourBaltic';
import TourLatinAmerica from './tours/TourLatinAmerica';
import TourCaminoDeSantiago from './tours/TourCaminoDeSantiago';
import TourCanadianRockies from './tours/TourCanadianRockies';
import TourWinterNorway from './tours/TourWinterNorway';
import TourTurkey from './tours/TourTurkey';
import TourRwandaAndUganda from './tours/TourRwandaAndUganda';
import TourWinterTurkey from './tours/TourWinterTurkey';

import TravelStories from './travelstories/TravelStories';
import TSDreamDestinations from './travelstories/DreamDestinations';
import TSMiracleAtLatitude69 from './travelstories/MiracleAtLatitude69';
import TSFaroeIsland from './travelstories/FaroeIsland';
import TSGreenland from './travelstories/Greenland';
import TSEasternAfrica from './travelstories/EasternAfrica';
import TSEcuador from './travelstories/Ecuador';

import Destinations from './destinations/Destinations';
import AboutUs from './aboutus/AboutUs';
import ContactUs from './contactus/ContactUs';
import DataPrivacy from './dataprivacy/DataPrivacy'
import TermsAndConditions from './termsandconditions/TermsAndConditions';

//import logo_lmt from '../assets/images/lmt-logo.png';
import logo_lmt_wht from '../assets/images/lmt-logo-wht.png';

import Navbar from "../widget/NavBar";
import GlobalStyle from '../assets/css/Global';


class Main extends Component {
	state = { 
		redirect: false, 
		route: '/', 
		menuCSS: 'header-wrapper',
		navbarOpen: false,
		lmtLogo: logo_lmt_wht};

	componentDidMount = () => {
		sessionStorage.setItem('openModal', true)
	}
	
	/*handleScroll = () => {
		var tempContent = document.getElementById('banner-content-wrapper').clientHeight;
		var eScrollTop = document.documentElement.scrollTop ;
		var top = 0;
		var bottom = top + tempContent;
	
		if (eScrollTop===0 || (top < eScrollTop && bottom > eScrollTop)) {
			this.setState({menuCSS: "header-wrapper"});
			this.setState({lmtLogo: logo_lmt_wht});
			//console.log("if" + eScrollTop + "===0 ||" + top + "<" + eScrollTop + "&&" + bottom + ">" + eScrollTop);
		} else {
			this.setState({menuCSS: "header-wrapper header-wrapper-white"});
			this.setState({lmtLogo: logo_lmt});
			//console.log("else" + eScrollTop + "===0 ||" + top + "<" + eScrollTop + "&&" + bottom + ">" + eScrollTop);
		}
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}
	
	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}*/

	handleNavbar = () => {
	this.setState({ navbarOpen: !this.state.navbarOpen });
	}
  	render() {
		return (
			<div className="main">
				<BrowserRouter>
					<div className="wrap">
						<div className="wrapper">	
							<div className="header-wrapper header-wrapper-white" id="header-wrapper" >
								{/*<div className={this.state.menuCSS} id="header-wrapper" >*/}
									{/*<Menu className="menu-wrapper" size="small" position="right">
										<Menu.Item className="item-logo">
											<img src={logo_lmt} className="logo-lmt" alt="Light Miles Travel" />
										</Menu.Item>
										<NavLink exact className="item" to="/">Home</NavLink>
										<NavLink className="item" to="/tours">Tours</NavLink>
										<NavLink className="item" to="/travelstories">Travel Stories</NavLink>
										<NavLink className="item" to="/destinations">Destinations</NavLink>
										<a className="item" href="https://www.instagram.com/lightmilestravel/" target="_blank" rel="noopener noreferrer">Instagram</a>
										<NavLink className="item" to="/aboutus">About us</NavLink>
										<NavLink className="item" to="/contactus">Contact us</NavLink>
									</Menu>*/}
									<Navbar 
										navbarState={this.state.navbarOpen} 
										handleNavbar={this.handleNavbar}
									/>
									<GlobalStyle />
								{/*</div>*/}
							</div>
							<div className="content-wrapper">
								<Switch>
									<Route exact path="/" component={Home}/>
									<Route exact path="/tours" component={Tours}/>
									<Route exact path="/tours/TourBalkan" component={TourBalkan}/>
									<Route exact path="/tours/TourNZ" component={TourNZ}/>
									<Route exact path="/tours/TourHolyLand" component={TourHolyLand}/>
									<Route exact path="/tours/TourIcelandSummer" component={TourIcelandSummer}/>
									<Route exact path="/tours/TourIcelandWinter" component={TourIcelandWinter}/>
									<Route exact path="/tours/TourCANY" component={TourCANY}/>
									<Route exact path="/tours/TourAfrica" component={TourAfrica}/>
									<Route exact path="/tours/TourBaltic" component={TourBaltic}/>
									<Route exact path="/tours/TourLatinAmerica" component={TourLatinAmerica}/>
									<Route exact path="/tours/TourCaminoDeSantiago" component={TourCaminoDeSantiago}/>
									<Route exact path="/tours/TourCanadianRockies" component={TourCanadianRockies}/>
									<Route exact path="/tours/TourWinterNorway" component={TourWinterNorway}/>
									<Route exact path="/tours/TourTurkey" component={TourTurkey}/>
									<Route exact path="/tours/TourRwandaAndUganda" component={TourRwandaAndUganda}/>
									<Route exact path="/tours/TourWinterTurkey" component={TourWinterTurkey}/>
									<Route exact path="/travelstories" component={TravelStories}/>
									<Route exact path="/travelstories/DreamDestinations" component={TSDreamDestinations}/>
									<Route exact path="/travelstories/MiracleAtLatitude69" component={TSMiracleAtLatitude69}/>
									<Route exact path="/travelstories/FaroeIsland" component={TSFaroeIsland}/>
									<Route exact path="/travelstories/Greenland" component={TSGreenland}/>
									<Route exact path="/travelstories/EasternAfrica" component={TSEasternAfrica}/>
									<Route exact path="/travelstories/Ecuador" component={TSEcuador}/>
									<Route exact path="/destinations" component={Destinations}/>
									<Route exact path="/aboutus" component={AboutUs}/>
									<Route exact path="/contactus" component={ContactUs}/>
									<Route exact path="/dataprivacy" component={DataPrivacy}/>
									<Route exact path="/termsandconditions" component={TermsAndConditions}/>
								</Switch>
							</div>
							
						</div>
						<div className="footer-wrapper" >
							
							<Grid className="footer-content-wrapper">
								<Grid.Column className="sitemap-wrapper" width={3}>
									<NavLink className="footer-link" to="/"><span>Home</span></NavLink>
									<NavLink className="footer-link" to="/aboutus"><span>About Us</span></NavLink> 
									<NavLink className="footer-link" to="/contactus"><span>Contact Us</span></NavLink> 
								</Grid.Column>
								<Grid.Column className="sitemap-wrapper" width={3}>
									<NavLink className="footer-link" to="/travelstories"><span>Travel Stories</span></NavLink> 
									<NavLink className="footer-link" to="/tours"><span>Tours</span></NavLink> 
									<NavLink className="footer-link" to="/continents"><span>Destinations</span></NavLink> 
								</Grid.Column>
								<Grid.Column className="sitemap-wrapper" width={3}>
									<a className="footer-link" href="https://www.instagram.com/lightmilestravel/" target="_blank" rel="noopener noreferrer"><span>Instagram</span></a> 
									<NavLink className="footer-link" to="/dataprivacy"><span>Data Privacy Policy</span></NavLink> 
									<NavLink className="footer-link" to="/termsandconditions"><span>Terms and Conditions</span></NavLink> 
								</Grid.Column>
								<Grid.Column className="sitemap-wrapper" width={7}>
									<img src={logo_lmt_wht} className="footer-logo-lmt-wht" alt="Light Miles Travel" />
								</Grid.Column>

							</Grid>
							<br></br>
							<hr></hr>
							<p className="copyright">Copyright &copy; 2020 Light Miles Travel, Inc. All rights reserved.</p>
							
						</div>
					</div>
				</BrowserRouter>
			</div>
		);
  	}
}

export default Main;